/**
 * Where the root's Clerk OAuth handoff may forward a `redirect_url` to.
 *
 * Clerk bounces OAuth requests through the sign-in page with a `redirect_url`
 * back into the flow. A signed-in user there would otherwise stay on Home and
 * strand the request, so the root forwards it — but only to:
 *
 * - a Clerk host over HTTPS, so the forwarded `__clerk_db_jwt` resume token
 *   can't be intercepted by a plain-HTTP listener or a tenant on a sibling apex
 *   domain. Clerk runs two hosts per tenant: the Frontend API
 *   (`clerk.<domain>` / `*.clerk.accounts.dev`) and the Account Portal
 *   (`accounts.<domain>` / `*.accounts.dev`);
 * - our own consent page (`routes/oauth-consent.tsx`), where Clerk Dashboard →
 *   Paths → "OAuth consent" sends the flow. Exact path only, on this origin or
 *   on app.cleanlist.ai, so this is never an open redirect. app.cleanlist.ai
 *   because Canada's bounce to the sign-in page lands on app.clugtm.com
 *   (public/_redirects), while the consent page stays on app.cleanlist.ai.
 */
const CONSENT_ORIGIN = 'https://app.cleanlist.ai';

export const isClerkOAuthHandoffTarget = (target: URL, origin: string) => {
  const isClerkHost =
    target.hostname === 'clerk.cleanlist.ai' ||
    target.hostname === 'accounts.cleanlist.ai' ||
    target.hostname.endsWith('.accounts.dev');
  if (target.protocol === 'https:' && isClerkHost) return true;
  if (target.pathname !== '/oauth-consent') return false;
  return target.origin === origin || target.origin === CONSENT_ORIGIN;
};
